import React from 'react'
import { StyleQuickLoginWrapper } from './style'
import { StyleText } from '@pages/front/commons/Text/style'

const FooterQuickLoginSection = () => {
  return (
    <StyleQuickLoginWrapper>
      <StyleText weight="600" color="#262f77">
        Quick Login
      </StyleText>
      <StyleText weight="300">Patient</StyleText>
      <StyleText weight="300">Doctors</StyleText>
      <StyleText weight="300">Health Service</StyleText>
    </StyleQuickLoginWrapper>
  )
}

export default FooterQuickLoginSection
